'use client';

import { getToken } from '@/lib/auth';
import { useAuthGate } from '@/context/AuthGateContext';
import { useUserData } from '@/context/UserDataContext';

function HeartIcon({ filled }: { filled: boolean }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round"
      stroke={filled ? '#8B6F47' : 'currentColor'}>
      <path
        d="M9 15.5S2 11 2 5.5A3.5 3.5 0 0 1 8.5 4L9 4.5L9.5 4A3.5 3.5 0 0 1 16 5.5C16 11 9 15.5 9 15.5Z"
        fill={filled ? '#8B6F47' : 'none'}
      />
    </svg>
  );
}

export default function FavoriteButton({ plantId, plantName }: { plantId: string; plantName: string }) {
  const { triggerAuthGate } = useAuthGate();
  const { favorites, saveFavorites } = useUserData();

  const saved = favorites.includes(plantId);

  function handleClick() {
    if (!getToken()) { triggerAuthGate(); return; }
    void saveFavorites(currentFavorites =>
      currentFavorites.includes(plantId)
        ? currentFavorites.filter(id => id !== plantId)
        : [...currentFavorites, plantId],
    );
  }

  return (
    <button
      onClick={handleClick}
      aria-label={saved ? `Remove ${plantName} from favorites` : `Save ${plantName} to favorites`}
      className={`inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 font-body text-[13px] font-semibold transition-colors duration-200 ${
        saved
          ? 'border-[#D6C8AE] bg-cream text-[#8B6F47]'
          : 'border-sand text-sage hover:border-[#D6C8AE] hover:bg-cream hover:text-[#8B6F47]'
      }`}
    >
      <HeartIcon filled={saved} />
      {saved ? 'Saved to Favorites' : 'Save to Favorites'}
    </button>
  );
}
